export default "__VITE_ASSET__DOONc25t__"